import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

const chuangban = [
  {
    name: "$singlee_bd2",
    text: "$singlee_bd3",
  },
  {
    name: "$singlee_bd4",
    text: "$singlee_bd5",
  },
];
const zxds = [
  {
    name: "$singlee_bd7",
    text: "$singlee_bd8",
  },
  {
    name: "$singlee_bd9",
    text: "$singlee_bd10",
  },
  {
    name: "$singlee_bd11",
    text: "$singlee_bd12",
  },
  {
    name: "$singlee_bd13",
    text: "$singlee_bd14",
  },
  {
    name: "$singlee_bd15",
    text: "$singlee_bd16",
  },
];
const dlfzxds = [
  {
    name: "$singlee_bd18",
    text: "$singlee_bd19",
  },
  {
    name: "$singlee_bd20",
    text: "$singlee_bd21",
  },
  // {
  //   name: "$singlee_bd22",
  //   text: "$singlee_bd23",
  // },
];
const manager = [
  {
    name: "$singlee_bd25",
    text: "$singlee_bd26",
  },
];

function Index() {
  const { t } = useTranslation();

  const [refFirst, styleFirst] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [refSecond, styleSecond] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [refThird, styleThird] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [refFourth, styleFourth] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.container}>
      <div className={css.title}>{t("$singlee_ab_md2")}</div>
      <div ref={refFirst} className={css.boxcontainer}>
        <animated.div style={styleFirst} className={css.box}>
          <div className={css.top}>
            <div className={css.secondtitle}>{t("$singlee_bd1")}</div>
            <div className={css.line}></div>
          </div>
          <div className={css.content}>
            {chuangban.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.name}>{t(item.name)}</div>
                  <div className={css.text}>{t(item.text)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>

      <div ref={refSecond} className={css.boxcontainer}>
        <animated.div style={styleSecond} className={css.box}>
          <div className={css.top}>
            <div className={css.secondtitle}>{t("$singlee_bd6")}</div>
            <div className={css.line}></div>
          </div>
          <div className={css.content}>
            {zxds.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.name}>{t(item.name)}</div>
                  <div className={css.text}>{t(item.text)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>

      <div ref={refThird} className={css.boxcontainer}>
        <animated.div style={styleThird} className={css.box}>
          <div className={css.top}>
            <div className={css.secondtitle}>{t("$singlee_bd17")}</div>
            <div className={css.line}></div>
          </div>
          <div className={css.content}>
            {dlfzxds.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.name}>{t(item.name)}</div>
                  <div className={css.text}>{t(item.text)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>

      <div ref={refFourth} className={css.boxcontainer}>
        <animated.div style={styleFourth} className={css.box}>
          <div className={css.top}>
            <div className={css.secondtitle}>{t("$singlee_bd24")}</div>
            <div className={css.line}></div>
          </div>
          <div className={css.content}>
            {manager.map((item, index) => {
              return (
                <div className={css.item} key={index}>
                  <div className={css.name}>{t(item.name)}</div>
                  <div className={css.text}>{t(item.text)}</div>
                </div>
              );
            })}
          </div>
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
